var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M2.96,3.26h0c-.45,9.59,6.72,17.85,16.28,18.74,.39,.02,.77-.11,1.06-.36,.3-.25,.48-.61,.5-.99l.25-3.62c.03-.39-.09-.77-.34-1.06-.25-.29-.6-.47-.98-.51-1.09-.1-2.16-.35-3.19-.75-.5-.22-1.09-.14-1.51,.22l-2.2,1.91c-1.24-.78-2.35-1.74-3.3-2.84h0c-.95-1.09-1.73-2.32-2.31-3.64l2.18-1.89c.4-.37,.57-.93,.43-1.46-.27-1.05-.39-2.13-.36-3.21,.02-.38-.11-.75-.36-1.03h0c-.26-.29-.62-.47-1.01-.5l-3.62-.25c-.75-.03-1.41,.51-1.53,1.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8df753bebee75562a9eb3edb49e1b75e.svg";
export { ForwardRef as ReactComponent };